import { SelectService } from '../services/select.service';
export class SelectableItem {
public _selected = false;
public children?: SelectableItem[];
public isOpen = false;
public matchFilter = true;
public isVisible = false;
/**
 * @param {?} id
 * @param {?} text
 * @param {?} data
 * @param {?} svc
 */
constructor(public id: string,
public text: string,
public data: any,
public svc: SelectService) {
  }
/**
 * @return {?}
 */
get hasChild(): boolean {
    return this.children && this.children.length > 0;
  }
/**
 * @return {?}
 */
get checked(): boolean {
    if (this.hasChild && this.svc.Configuration.allowMultiple) {
      if (this.children.every((child) => child.selected)) {
        return true;
      } else if (this.children.every((child) => child.selected === false)) {
        return this._selected;
      }
      return null;
    }
    return this._selected;
  }
/**
 * @return {?}
 */
get selected(): boolean {
    if (this.hasChild && this.svc.Configuration.allowMultiple) {
      if (this.children.some((child) => child.selected)) {
        if (this.svc.Configuration.allowParentSelection) {
          this._selected = false;
        }
        return true;
      } else if (this.children.every((child) => child.selected === false)) {
        if (this.svc.Configuration.allowParentSelection) {
          return this._selected;
        } else {
          return this._selected = false;
        }
      }
      return false;
    } else if (this.hasChild && this._selected === true) {
      for (const /** @type {?} */ itm of this.children) {
        itm.selected = false;
      }
    }

    return this._selected;
  }
/**
 * @param {?} value
 * @return {?}
 */
set selected(value: boolean) {
    if (this.hasChild && !this.svc.Configuration.allowParentSelection) {
      if (value !== null) {
        this.children.forEach((child) => child.selected = value);
      }
    } else {
      this._selected = value;
    }
  }
}

function SelectableItem_tsickle_Closure_declarations() {
/** @type {?} */
SelectableItem.prototype._selected;
/** @type {?} */
SelectableItem.prototype.children;
/** @type {?} */
SelectableItem.prototype.isOpen;
/** @type {?} */
SelectableItem.prototype.matchFilter;
/** @type {?} */
SelectableItem.prototype.isVisible;
/** @type {?} */
SelectableItem.prototype.id;
/** @type {?} */
SelectableItem.prototype.text;
/** @type {?} */
SelectableItem.prototype.data;
/** @type {?} */
SelectableItem.prototype.svc;
}

